/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button } from "components/Button";
import { useStepperContext } from "components/Steps";
import { ArrowBack as IconArrowBack } from "@material-ui/icons";
import * as S from "./styles";
import { Skeleton } from "components/Skeleton";
import { WrapperBanks } from "components/WrapperBanks";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ButtonContact } from "components/ButtonContact";

interface DetailsResultPriceProps {
  creditAmountFormated: any;
  propertyAmountFormated: any;
  result: any;
  showInterestRate?: boolean;
}

export function DetailsResultPrice({
  propertyAmountFormated,
  creditAmountFormated,
  result,
  showInterestRate = true,
}: DetailsResultPriceProps) {
  const { goToPreviousStep } = useStepperContext();
  const location = useLocation();

  const [creditWithProperty, setCreditWithProperty] = useState(true);

  useEffect(() => {
    setCreditWithProperty(location.pathname.includes("credito-com-imovel"));
  }, [location]);

  return (
    <>
      <S.Container>
        <S.Title>
          O <strong>Comparetaxa</strong> comparou e escolheu o melhor para você!
        </S.Title>

        {creditWithProperty ? (
          <S.SubTitle>
            Para um crédito de <strong>{creditAmountFormated}</strong> com um
            imóvel no valor de <strong>{propertyAmountFormated}</strong> como
            garantia:
          </S.SubTitle>
        ) : (
          <S.SubTitle>
            Para um financiamento de <strong>{creditAmountFormated}</strong> no
            sistema de amortização <strong>PRICE</strong>:
          </S.SubTitle>
        )}

        <S.WrapperResults>
          <S.ResultItem>
            <h3>Renda bruta mínima necessária</h3>

            <Skeleton showSkeleton={!result}>
              <span>{result?.minimumGrossIncomeRequired}</span>
            </Skeleton>
          </S.ResultItem>
          <S.ResultItem>
            <h3>Valor da parcela</h3>
            <Skeleton showSkeleton={!result}>
              <span>{result?.portionAmount}</span>
            </Skeleton>
          </S.ResultItem>
          <S.ResultItem>
            <h3>Prazo de pagamento</h3>

            <Skeleton showSkeleton={!result}>
              <span>{result?.paymentTerm}</span>
            </Skeleton>
          </S.ResultItem>

          {showInterestRate && (
            <S.ResultItem>
              <h3>Taxa de juros</h3>

              <Skeleton showSkeleton={!result}>
                <span>{result?.interestRate}</span>
              </Skeleton>
            </S.ResultItem>
          )}
        </S.WrapperResults>

        <S.WrapperButtons>
          <Button
            onClick={goToPreviousStep}
            startIcon={<IconArrowBack />}
            variant="outlined"
          >
            AJUSTAR SIMULAÇÃO
          </Button>
          <ButtonContact />
        </S.WrapperButtons>

        {creditWithProperty ? (
          <S.WrapperTerms>
            <p>
              A PRESTAÇÃO ACIMA FOI CALCULADA SEM INDEXADOR NÃO HAVENDO NENHUMA
              VARIAÇÃO NA PRESTAÇÃO, SITES CONCORRENTES COSTUMAM SIMULAR COM
              ÍNDICE IPCA, O QUE PODE ALTERAR O VALOR DA PRESTAÇÃO NO DECORRER DO
              EMPRÉSTIMO, CASO PREFIRA SIMULAR COM IPCA, FAVOR SOLICITAR A UM DE
              NOSSOS CONSULTORES, PODEMOS SIMULAR EM TODOS OS BANCOS COM E SEM
              INDEXADOR
            </p>
          </S.WrapperTerms>
        ) : (
          <S.WrapperTerms>
            <p>
              TODAS AS NOSSAS SIMULAÇÕES DO SITE ESTÃO COM BASE NO ÍNDICE TR,
              SENDO QUE ESTE ÍNDICE É O MAIS TRADICIONAL NO <br /> CRÉDITO
              IMOBILIÁRIO E NÃO COSTUMA TER VARIAÇÕES, SENDO A PRESTAÇÃO
              SIMULADA BEM PRÓXIMO DA REALIDADE A PAGAR.
            </p>

            <p>
              SITES CONCORRENTES PODEM APRESENTAR PRESTAÇÕES APARENTEMENTE
              MENORES MAS FIQUEM ATENTOS COM OS ÍNDICES <br /> UTILIZADOS (IPCA,
              CORREÇÃO DE POUPANÇA), POIS ESTES OUTROS ÍNDICES PODEM TRAZER
              GRANDES VARIAÇÕES NAS <br /> PRESTAÇÕES NO DECORRER DO PRAZO DE
              FINANCIAMENTO..
            </p>

            <p>
              CASO PREFIRA OUTRO ÍNDICE QUE NÃO SEJA A TR, FAVOR SOLICITAR A UM
              DE NOSSOS CONSULTORES
            </p>
          </S.WrapperTerms>
        )}

        {!creditWithProperty && <WrapperBanks />}
      </S.Container>
    </>
  );
}
